<template>
  <div class="p-order">
    <div class="c-header">
      <div class="c-header__content">
        <h1>Serwis Inchcape</h1>
        <a href="/"><img src="@/assets/Inchcape_Flat_logo_Digi_Use_Horz_dk_blue_rgb_LR.png" alt="Serwis Inchcape Wrocław"
            class="c-header__logo" /></a>
      </div>
    </div>
    <template v-if="order">
      <h2 class="p-order__header">Sprawdź na jakim etapie serwisu jest Twój samochód</h2>
      <h3 class="p-order__subheader">
        Zgłoszenie nr: <strong>{{ $route.params.code }}</strong> /#{{ order.id }}
      </h3>
      <div class="p-order__row">
        <div class="p-order__col">
          <span class="p-order__label" v-if="order.admission_date">Termin przyjęcia: <strong>{{ order.admission_date
          }}</strong></span>
          <br><br><br>
          <span class="p-order__label" v-if="order.advisor_name">Doradca przyjmujący zlecenie:</span>
          <div class="p-order__employee" v-if="order.advisor_name">
            <strong>{{ order.advisor_name }}</strong>
            <small v-if="order.advisor_phone_number">
              <br><br>
              tel.: <a :href="`tel:${order.advisor_phone_number}`">{{ order.advisor_phone_number }}</a>,
              <br>
              email: <a :href="`mailto:${order.advisor_email}`">{{ order.advisor_email }}</a>
            </small>
          </div>
        </div>
      </div>
      <div class="p-order__row">
        <div class="p-order__col">

        </div>
      </div>
      <div class="p-order__row">
        <div class="p-order__col">
          <span class="p-order__label">Numer rejestracyjny</span>
          <span class="p-order__value">{{ order.registration_number }}</span>
        </div>
      </div>
      <div class="p-order__timeline">
        <div class="p-order__timeline-status" v-for="(item, key) in history" :key="item.status_id">
          <div class="p-order__timeline-status-left">
            {{ item.status_id === 580 ? item.date.split(' ')[0] : item.date }}
            <div class="p-order__timeline-status-check" v-if="key != 0">
              <svg xmlns="http://www.w3.org/2000/svg" width="12.661" height="9.111" viewBox="0 0 12.661 9.111">
                <g id="check" transform="translate(0 -71.788)">
                  <g id="Group_4" data-name="Group 4" transform="translate(-0.001 71.788)">
                    <path id="Path_1" data-name="Path 1"
                      d="M12.367,72.082a1,1,0,0,0-1.42,0L4.555,78.474,1.714,75.634a1,1,0,0,0-1.42,1.42L3.845,80.6a1,1,0,0,0,1.42,0l7.1-7.1A1,1,0,0,0,12.367,72.082Z"
                      transform="translate(0.001 -71.788)" fill="#fff" />
                  </g>
                </g>
              </svg>
            </div>
            <div class="p-order__timeline-status-current" v-if="key == 0">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="51.627" height="51.627" viewBox="0 0 51.627 51.627">
                  <g id="check" transform="translate(5.062 10.776)">
                    <g id="Group_4" data-name="Group 4">
                      <g id="refresh" transform="translate(-16.062 -21.776)">
                        <path id="Path_2" data-name="Path 2"
                          d="M60.477,34.664a2.145,2.145,0,0,0-2.149,2.149,21.506,21.506,0,1,1-4.962-13.75H45.938a2.149,2.149,0,1,0,0,4.3H58.012a2.145,2.145,0,0,0,2.149-2.149V13.149a2.149,2.149,0,0,0-4.3,0v6.216a25.833,25.833,0,1,0,6.764,17.448A2.145,2.145,0,0,0,60.477,34.664Z"
                          fill="#fff" />
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
            </div>
          </div>
          <div class="p-order__timeline-status-right">
            <div v-if="key == 0">
              <h1>{{ item.type_name ? item.type_name : item.status_name }}</h1>
              <br>
              <strong v-html="communique[item.status_id]" v-if="communique[item.status_id]"></strong>
              <span v-if="[7, 3].includes(item.type_id)">Twój termin zmienił się na:<br>{{ item.date }}</span>
            </div>
            <template v-if="key != 0">
              <div>
                {{ item.type_name ? item.type_name : item.status_name }}
                <small v-if="[7, 3].includes(item.type_id)"><br>Twój termin zmienił się na:<br>{{ item.date }}</small>
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="order === null">
      <h2 class="p-order__header">
        Trwa aktualizacja statusu naprawy.<br />Może to zająć kilka minut.
      </h2>
      <h3 class="p-order__subheader">
        Zgłoszenie nr: <strong>{{ $route.params.code }}</strong>
      </h3>
    </template>
  </div>
</template>
<script>
export default {
  data() {
    return {
      order: null,
      communique: {
        100: "Twoja wizyta serwisowa została potwierdzona.",
        200: "Twój pojazd został przyjęty i&nbsp;oczekuje na naprawę.",
        300: "Twój pojazd jest w trakcie wykonywania usług serwisowych.",
        550: "Twój samochód jest przygotowywany do wydania po serwisie.",
        580: "Twój samochód jest gotowy do wydania.",
        600: "Twoja wizyta serwisowa została zakończona. Dziękujemy za zaufanie.",
      },
    };
  },
  computed: {
    history() {
      return [
        ...this.order.admission_history,
        ...this.order.status_history.map(e => { return { ...e, updated_at: e.date } })
        // .map(e => {
        //   let term = { ...e }
        //   return {
        //     ...e,
        //     updated_at: term.date,
        //     date: term.updated_at ? term.updated_at : term.date
        //   }
        // })
      ].sort((a, b) => new Date(a.updated_at) + new Date(b.updated_at))
    }
  },
  methods: {
    async getStatus() {
      let code = this.$route.params.code;
      const response = await this.axios.get(`/service/order-history/?code=${code}`);
      setTimeout(() => {
        this.order = response.data.order;
      }, 1000);
    },
  },
  created() {
    this.getStatus();
  },
};
</script>
<style lang="scss">
.p-order {
  font-family: "Century Gothic", sans-serif;
  font-size: 16px;

  a {
    color: #000;
  }

  strong {
    color: #000;
  }

  &__header {
    width: 100%;
    text-align: center;
    font-weight: bold;
    margin-top: 7vh;
    font-size: 1.7rem;
  }

  &__subheader {
    width: 100%;
    text-align: center;
    font-weight: bold;
    font-size: 1.25rem;
    color: #bbbbbb;

    strong {
      color: #000;
    }
  }

  .c-header {
    padding-bottom: 0;
  }

  &__row {
    margin: 4rem 0;
    display: flex;
    justify-content: center;
  }

  &__col {
    width: 100%;
    max-width: 254px;
    text-align: center;
  }

  &__label {
    color: #bbbbbb;
  }

  &__value {
    display: block;
    font-size: 3.6rem;
    font-weight: lighter;
  }

  &__timeline {
    max-width: 590px;
    margin: 0 auto;
    padding: 0 1rem;

    &-status {
      display: flex;
      justify-content: center;

      &-left {
        border-right: 2px solid #bbbbbb;
        width: 100%;
        color: #000;
        padding: 1.25rem 0 1.25rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        @media (max-width: 650px) {
          font-size: 1rem;
        }
      }

      &-right {
        width: 100%;
        padding: 1rem;
        padding: 1.25rem 0 1.25rem 2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // text-transform: capitalize;

        p {
          margin: 10px 0 0 0;
        }
      }

      &-check {
        background-color: #bbbbbb;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &-current {
        // background-color: #0066b2;
        background-color: #f2e61a;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;

        svg {
          max-width: 25px;
          max-height: 25px;
        }
      }
    }
  }

  &__employee {
    text-align: center;
    width: 100%;
    display: block;
    margin: 1.5rem 0;
    // border-left: 2px solid #bbbbbb;
    padding: 0 1rem;
    color: #bbbbbb;
    // min-width: 300px;
  }
}
</style>
